import { render, staticRenderFns } from "./AddStudentAccount.vue?vue&type=template&id=556b0a54&scoped=true"
import script from "./AddStudentAccount.vue?vue&type=script&lang=ts"
export * from "./AddStudentAccount.vue?vue&type=script&lang=ts"
import style0 from "./AddStudentAccount.vue?vue&type=style&index=0&id=556b0a54&prod&scoped=true&lang=scss"
import style1 from "./AddStudentAccount.vue?vue&type=style&index=1&id=556b0a54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556b0a54",
  null
  
)

export default component.exports